<div class="p-10">
    <form nz-form [formGroup]="serviceDetailForm">
        @if(showAllocations) {
        <div nz-row>
            <div nz-col style="margin-left: 8px; margin-right: 8px; width: 100%;">
                <nz-form-item>
                    <nz-form-label  [nzSm]="10" [nzXs]="24" nzFor="authorizationProviderId"
                        class="ppl-form-label">
                        Provider Allocation
                    </nz-form-label>
                    <nz-form-control>
                        <nz-select formControlName="authorizationProviderId" class="filters" id="authorizationProviderId"
                            nzPlaceHolder="Select Provider Allocation" nzShowSearch nzAllowClear="true"
                            style="width: 100%;"
                            [nzStatus]="serviceDetailForm.get('authorizationProviderId')?.invalid && serviceDetailForm.get('authorizationProviderId')?.touched ? 'error' : ''">
                            <nz-option *ngFor="let opt of allocations" [nzLabel]="opt.allocationLabel"
                                [nzValue]="opt.authorizationProviderId">
                            </nz-option>
                        </nz-select>

                        <div
                            *ngIf="serviceDetailForm.controls['authorizationProviderId'].errors?.['required'] && serviceDetailForm.controls['authorizationProviderId'].touched">
                            <div nz-form-explain class="error-message">Please select Provider Allocation.</div>
                        </div>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>
        }
        <div nz-row>
            <div nz-col style="margin-left: 8px; margin-right: 8px; width: 100%;">
                <nz-form-item>
                    <nz-form-label  [nzSm]="10" [nzXs]="24" nzFor="serviceDetail" class="ppl-form-label">
                        Service Detail
                    </nz-form-label>
                    <nz-form-control>
                        <input formControlName="serviceDetail" nz-input id="serviceDetail"
                            placeholder="Service Detail" />

                        <div
                            *ngIf="serviceDetailForm.controls['serviceDetail'].errors?.['required'] && serviceDetailForm.controls['serviceDetail'].touched">
                            <div nz-form-explain class="error-message">Please enter Service Detail.</div>
                        </div>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>

        <div nz-row>
            <div nz-col style="margin-left: 8px; margin-right: 8px; width: 100%;">
                <nz-form-item>
                    <nz-form-label  [nzSm]="10" [nzXs]="24" nzFor="serviceUnits" class="ppl-form-label">
                        Unit
                    </nz-form-label>
                    <nz-form-control>
                        <input formControlName="units" nz-input id="serviceUnits" type="number" min="0.001" step="0.001"
                            placeholder="Unit" />

                        @if(serviceDetailForm.controls['units'].touched) {
                        <div *ngIf="serviceDetailForm.controls['units'].errors?.['required']">
                            <div nz-form-explain class="error-message">Please enter Unit.</div>
                        </div>
                        <div
                            *ngIf="serviceDetailForm.controls['units'].errors?.['pattern'] || serviceDetailForm.controls['units'].errors?.['min']">
                            <div nz-form-explain class="error-message">Unit must be greater than zero with up to three
                                decimal places.</div>
                        </div>
                        <div *ngIf="serviceDetailForm.controls['units'].errors?.['max']">
                            <div nz-form-explain class="error-message">Unit cannot exceed 9999.</div>
                        </div>
                        }
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>

        <div nz-row>
            <div nz-col style="margin-left: 8px; margin-right: 8px; width: 100%;">
                <nz-form-item>
                    <nz-form-label  [nzSm]="10" [nzXs]="24" nzFor="price" class="ppl-form-label">
                        Price per Unit
                    </nz-form-label>
                    <nz-form-control>
                        <nz-input-group nzPrefix="$">
                            <input formControlName="price" nz-input id="price" type="number" min="0.001" step="0.001"
                                placeholder="Price per Unit" />
                        </nz-input-group>

                        @if(serviceDetailForm.controls['price'].touched) {
                        <div *ngIf="serviceDetailForm.controls['price'].errors?.['required']">
                            <div nz-form-explain class="error-message">Please enter Price per Unit.</div>
                        </div>
                        <div
                            *ngIf="serviceDetailForm.controls['price'].errors?.['pattern'] || serviceDetailForm.controls['price'].errors?.['min']">
                            <div nz-form-explain class="error-message">Price per Unit must be greater than zero with up to three
                                decimal places.</div>
                        </div>
                        }
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>

        <div nz-row>
            <div nz-col style="margin-left: 8px; margin-right: 8px; width: 100%;">
                <nz-form-item>
                    <nz-form-label  [nzSm]="10" [nzXs]="24" nzFor="frequency" class="ppl-form-label">
                        Frequency
                    </nz-form-label>
                    <nz-form-control>
                        <nz-select formControlName="frequency" class="filters" id="frequency"
                            nzPlaceHolder="Select Frequency" nzShowSearch nzAllowClear="true" style="width: 100%;"
                            [nzStatus]="serviceDetailForm.get('frequency')?.invalid && serviceDetailForm.get('frequency')?.touched ? 'error' : ''">
                            <nz-option *ngFor="let opt of frequencies" [nzLabel]="opt.label" [nzValue]="opt.value">
                            </nz-option>
                        </nz-select>

                        <div
                            *ngIf="serviceDetailForm.controls['frequency'].errors?.['required'] && serviceDetailForm.controls['frequency'].touched">
                            <div nz-form-explain class="error-message">Please select Frequency.</div>
                        </div>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>
        <div nz-row>
            <div nz-col style="margin-left: 8px; margin-right: 8px; width: 100%;">
                <nz-form-item>
                    <nz-form-label  [nzSm]="10" [nzXs]="24" nzFor="startDate" class="ppl-form-label">
                        Start Date
                    </nz-form-label>
                    <nz-form-control>
                        <ppl-date-picker formControlName="startDate" id="startDate"
                            dateFormat="mm/dd/yy" [yearRange]="'1900:2050'"
                            [iconDisplay]="'input'" inputId="icondisplay"
                            [panelStyleClass]="'custom-calendar-panel'"
                            [placeholder]="'Select'">
                        </ppl-date-picker>

                        <div
                            *ngIf="serviceDetailForm.controls['startDate'].errors?.['required'] && serviceDetailForm.controls['startDate'].touched">
                            <div nz-form-explain class="error-message">Please select Start Date.</div>
                        </div>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>
        <div nz-row>
            <div nz-col style="margin-left: 8px; margin-right: 8px; width: 100%;">
                <nz-form-item>
                    <nz-form-label  [nzSm]="10" [nzXs]="24" nzFor="endDate" class="ppl-form-label">
                        End Date
                    </nz-form-label>
                    <nz-form-control>
                        <ppl-date-picker formControlName="endDate" id="endDate"
                            dateFormat="mm/dd/yy" [yearRange]="'1900:2050'"
                            [iconDisplay]="'input'" inputId="icondisplay"
                            [panelStyleClass]="'custom-calendar-panel'"
                            [placeholder]="'Select'">
                        </ppl-date-picker>
                        <div
                            *ngIf="serviceDetailForm.controls['endDate'].errors?.['required'] && serviceDetailForm.controls['endDate'].touched">
                            <div nz-form-explain class="error-message">Please select End Date.</div>
                        </div>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>
    </form>

    <div class="custom-row">
        <ppl-button [label]="isEdit ? 'Update Service Detail' : 'Add Service Detail'" icon="fa fa-check-circle"
            [customClass]="'primary-button'" [iconPosition]="'left'" (click)="onSubmit()"></ppl-button>
        @if(isEdit) {
        <ppl-button label="Deactivate" icon="fa fa-trash" [customClass]="'ghost-button'" [iconPosition]="'left'"
            (click)="deactivate.emit()"></ppl-button>
        }
    </div>
</div>
